@if (getImage(message.photoRemoteId)) {
  <div class="container">
    <img
      class="message-img"
      [src]="getImage(message.photoRemoteId)"
      alt=""
    >
    <button
      mat-mini-fab
      class="open-image"
      (click)="handleOpenImage(message.photoRemoteId)"
    >
      <mat-icon>zoom_out_map</mat-icon>
    </button>
  </div>


} @else {
  <div class="skeleton-loader message-img">
    Загрузка...
  </div>
}
